import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NewslettersService} from "../../../../services/newsletters.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NewsletterInfo} from "../../../../models/newsletterInfo.model";
import Swal from "sweetalert2";
import {User} from "../../../../models/user.model";
import { nameValidator } from '../../validators/validator';

@Component({
  selector: 'app-newletter',
  templateUrl: './newletter.component.html',
  styleUrls: ['./newletter.component.scss']
})

export class NewletterComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('btnSubmit') btnSubmit: ElementRef;
  newsletters = [];
  newslettersTmp = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;

  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;

  perPage = 10;
  constructor(private newsletterService : NewslettersService,
              private fb: FormBuilder,private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.getNewsletter();
    },error=>{
      this.router.navigate(['/login']);
    });
  }
  get f2() { return this.newsLetterForm.controls; }

//   newsLetterForm = this.fb.group({
//     'object': ['', { validators: nameValidator('L\'objet de la newsletter', 2, 500), updateOn: 'change'}],
//     'message': ['', Validators.required],
//   }
// );

newsLetterForm = this.fb.group({
  'object': ['', { validators: [Validators.required, Validators.minLength(2), Validators.maxLength(500)], updateOn: 'change'}],
  'message': ['', Validators.required],
});

  model = {
    object: '',
    message: ''
  };

  onSubmit() {
    if(this.newsLetterForm.valid){
      let newsletterInfo = new NewsletterInfo()
      const newsletterInfo1: NewsletterInfo = this.newsLetterForm.value;
     // console.log(newsletterInfo1);

      newsletterInfo.object = this.model.object;
      newsletterInfo.message = this.model.message;
      //this.btnSubmit.nativeElement.disabled = true;

      Swal.fire({
        title: 'Traitement en cours...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // // Exemple d'utilisation : simulation d'une opération asynchrone
      // setTimeout(() => {
      //   // Une fois que l'opération asynchrone est terminée, fermez SweetAlert
      //   Swal.close();
      // }, 3000); 
      this.newsletterService.sendNewsletterInfos(newsletterInfo).subscribe(rs=>{
        //this.btnSubmit.nativeElement.disabled = true;
        Swal.close();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Email envoyé avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
      },error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Erreur lors de l\'envoie du mail',
          showConfirmButton: false,
          timer: 1500
        });
      });
      //console.log( `Form submit, model: ${ JSON.stringify( this.model ) }` );
    }

  }

  close() {
    this.closebutton.nativeElement.click();
    //this.reloadComponent()
  }

  getNewsletter(){
    this.newsletterService.getAllNewsLetters().subscribe(rs=>{
      this.newsletters = rs;
      this.newslettersTmp = rs;
     // console.log(rs);
    });
  }

  // searchFilter(KeyboardEvent) {
  //   if(KeyboardEvent.target.value){
  //     this.newsletters = this.newsletters.filter(value =>
  //       value?.createdAt?.toUpperCase().includes(this.search) || value.createdAt?.toLowerCase().includes(this.search) ||
  //       value?.email?.toUpperCase().includes(this.search) || value.email?.toLowerCase().includes(this.search)
  //     );
  //   }else{
  //     this.newsletters = this.newslettersTmp;
  //   }
  // }
  searchFilter(KeyboardEvent) {
    if (KeyboardEvent.target.value) {
      const searchValue = KeyboardEvent.target.value.toLowerCase();
      this.newsletters = this.newslettersTmp.filter(value =>
        value?.createdAt?.toLowerCase().includes(searchValue) ||
        value?.email?.toLowerCase().includes(searchValue)
      );
    } else {
      this.newsletters = this.newslettersTmp;
    }
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.tableSize);
  }

  sort0() {
    if(this.sorted == false) {
      // @ts-ignore
      this.newsletters.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
      this.sorted = true;

    } else {
      // @ts-ignore
      this.newsletters.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
      this.sorted = false;

    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.newsletters.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted1 = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted1 = false;
    }
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

}
